import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams, Link } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Icon,
  Typography
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { format, parseISO } from 'date-fns';
import { extractAttributesValues } from '../helpers';
import { useStyles } from '../styles';
import SearchPatient from '../QuotePatient/SearchPatient';
import SubscriptionInfo from './SubscriptionInfo';
import nextechlogo from './icons/nextechlogo.svg';


const QuotePatientData = () => {
  const classes = useStyles();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const history = useHistory();
  const { id } = useParams<{id?: string}>();

  const {
    currentQuoteCustomer,
    loadingQuoteCustomers,
  } = useSelector((state: IReduxState) => state.quote);
  const { chargesByCustomer } = useSelector((state: IReduxState) => state.rpa);
  const email = currentQuoteCustomer?.email;

  const avatarLetters = `${currentQuoteCustomer?.firstname[0]}${currentQuoteCustomer?.lastname[0]}`;
  const formattedPurchaseDate = currentQuoteCustomer?.created_at
    ? format(parseISO(currentQuoteCustomer.created_at), 'MM/yyyy')
    : '';
  const {phone_number, practice_name} = extractAttributesValues(currentQuoteCustomer?.custom_attributes, ['phone_number', 'practice_name']);
  const isPatientAccountDataExist = Boolean(
    chargesByCustomer?.length
  );

  const [searchPatientModalOpen, setSearchPatientModalOpen] = useState(false);

  return (
    <>
      <Card className={`px-4 pt-4 pb-6 root-card ${classes.gridItem}`}>
        <Grid container spacing={4}>
          <Grid item className="flex" alignItems="flex-start" xs={12} sm={6}>
            <Avatar className={classes.avatar}>{avatarLetters}</Avatar>
            <div>
              <Typography variant="h5">
                {`${currentQuoteCustomer?.firstname || ''} ${currentQuoteCustomer?.lastname || ''}`}
              </Typography>
              {formattedPurchaseDate && (
                <Typography className="text-muted text-12">
                  {`${isCustomer3 ? 'Customer' : 'Patient'} since`} {formattedPurchaseDate}
                </Typography>
              )}
            </div>
          </Grid>
          <Grid item container xs={12} sm={6} spacing={1}>
            <Grid item xs={12} className="flex" justifyContent="flex-end" alignItems="center">
              <Button
                onClick={() => history.push(`/quoting/profile/${id}/quote-workspace/patient-activity`)}
                size="small"
                className={classes.patientActivityButton}
                startIcon={<Icon>recent_actors</Icon>}
              >
                {isCustomer3 ? 'Customer Activity' : 'Patient Activity'}
              </Button>
            </Grid>
            <Grid item xs={12} className="flex" justifyContent="flex-end">
              <Button
                component={Link}
                to="#"
                onClick={() => setSearchPatientModalOpen(true)}
                size="small"
                className={classes.changePatient}
                startIcon={<Icon>account_circle</Icon>}
              >
                {`Change ${isCustomer3 ? 'customer' : 'patient'}`}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={4} className={classes.patientContainer}>
          <Grid item xs={12} md={6}>
            {isCustomer3 &&
            <>
              <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
                <Typography className="text-muted text-12">
                  Company/Practice Name
                </Typography>
                <Typography variant="h6" className="text-12">
                  {practice_name}
                </Typography>
              </Box>
              <Divider />
            </>
            }
            <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
              <Typography className="text-muted text-12">
                Mobile
              </Typography>
              <Typography variant="h6" className="text-12">
                {phone_number}
              </Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
              <Typography className="text-muted text-12">
                Email
              </Typography>
              <Typography variant="h6" className="text-12">
                {email}
              </Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
              <Typography className="text-muted text-12">
                Date of Birth
              </Typography>
              <Typography variant="h6" className="text-12">
                {new Date(currentQuoteCustomer?.dob).toLocaleDateString('en-US', { timeZone: 'UTC' })}
              </Typography>
            </Box>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            {isPatientAccountDataExist &&
              <>
                <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
                  <Typography className="text-muted text-12">Accounts</Typography>
                  <div className={classes.logoContainer}>
                    {!!chargesByCustomer?.length &&
                    <div className={classes.logo}>
                      <img src={nextechlogo} alt="Alle Logo" width="60" height="60" />
                    </div>
                    }
                  </div>
                </Box>
                <Divider />
              </>
            }
            <SubscriptionInfo id={id} />
          </Grid>
        </Grid>
        <SearchPatient open={searchPatientModalOpen} onClose={() => setSearchPatientModalOpen(false)} />
      </Card>
      <BackdropCircular loading={loadingQuoteCustomers} />
    </>
  );
};

export default QuotePatientData;
